export const ADD_ACTION_TENDENCY = 'ADD_ACTION_TENDENCY';
export const DELETE_ACTION_TENDENCY = 'DELETE_ACTION_TENDENCY';
export const INIT_REGULATION = 'INIT_REGULATION';
export const SAVE_REGULATION__BEGIN = 'SAVE_REGULATION__BEGIN';
export const SAVE_REGULATION__RESOLVE = 'SAVE_REGULATION__RESOLVE';
export const SET_AROUSAL_SCORES = 'SET_AROUSAL_SCORES';
export const SET_EMOTION_AROUSAL_SCORE = 'SET_EMOTION_AROUSAL_SCORE';
export const SET_EMOTION_ATTENUATION = 'SET_EMOTION_ATTENUATION';
export const SET_INPUTS = 'SET_INPUTS';
export const SET_OUTPUTS = 'SET_OUTPUTS';
